import { getDataModel } from '@/services/angularjs-bridge';

import { BrowseActiveFilter, FILTER_TYPE } from '../../types';

/**
 * Mirror Angular `translateFilter` in `filters.js` so category chips show
 * "Simple Item" instead of `DemoModel::SimpleDemoItem`.
 */
export function formatFilterBadgeLabel(
    filter: BrowseActiveFilter,
    t: (key: string) => string,
): string {
    if (filter.type === FILTER_TYPE.CATEGORY) {
        if (filter.name.includes('::')) {
            const i18nKey = `category.${filter.name}`;
            const translated = t(i18nKey);
            if (translated !== i18nKey) {
                return translated;
            }
            try {
                const category = getDataModel()?.category?.(filter.name) as
                    | { translatedLabel?: string; label?: string }
                    | undefined;
                return category?.translatedLabel || category?.label || filter.name;
            } catch {
                return filter.name;
            }
        }
        return t(filter.name);
    }

    return t(filter.name);
}
